//
import { mapActions, mapState } from 'vuex'
import {
    ModelAutocomplete,
    ModelDataTable,
    ModelForm,
} from '@/components/reusable_components/next'
import TranslatorService from '@/services/translator'

//
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import WarehouseTypeModel from '@/models/Warehouse/WhWarehouseType'
import fields from './fields'
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'warehouse-list',
    components: {
        'model-autocomplete': ModelAutocomplete,
        'crud-data-table': ModelDataTable,
        ModelForm,
    },
    computed: {
        /**
         *
         */
        createFormProps() {
            return {
                fields: fields.warehouse,
            }
        },

        /**
         *
         */
        createTypeFormProps() {
            return {
                fields: fields.warehouseType,
            }
        },

        /**
         *
         */
        tableProps() {
            return {
                service: WarehouseModel,
                filters: filters({
                    g_branch_office_address: this.user.hr_employee
                        .g_branch_office.address,
                }),
                headers,
            }
        },

        /**
         *
         */
        updateFormProps() {
            return {
                editable: false,
                fields: fields.warehouse,
                switchEdit: this.$can('EDIT_WAREHOUSE'),
            }
        },

        //
        ...mapState('AuthModule', ['user']),

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    data() {
        return {
            warehouse: false,
            warehouseType: false,
            warehouseFormData: new WarehouseModel({
                is_waste_warehouse: true,
            }),
            warehouseTypeFormData: new WarehouseTypeModel(),
            selected: null,
            update: false,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
            setItemsTopBar: 'setItemsTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            setSnackbar: 'setSnackbar',
        }),

        /**
         *
         */
        closeUpdate() {
            this.update = false
        },

        /**
         *
         */
        closeWarehouse() {
            this.warehouse = false
            this.warehouseFormData = new WarehouseModel()
        },

        /**
         *
         */
        closeWarehouseType() {
            this.warehouseType = false
        },

        /**
         *
         */
        createWarehouse(model) {
            model
                .toCreate()
                .save()
                .then(this.successWarehouse)
                .then(this.closeWarehouse)
                .catch(this.errorWarehouse)
                .then(this.$refs.warehouseForm.setWait)
                .then(this.$refs.table.refresh)
        },

        /**
         *
         */
        createWarehouseType(model) {
            model
                .toCreate()
                .save()
                .then(this.successWarehouseType)
                .then(this.closeWarehouseType)
                .catch(this.errorWarehouseType)
                .then(this.$refs.warehouseTypeForm.setWait)
                .then(this.$refs.table.refresh)
        },

        /**
         *
         */
        errorWarehouse(error) {
            this.setSnackbar({
                type: 'error',
                title: 'Error.',
                message: TranslatorService(WarehouseModel, error.response.data),
                timeout: 3000,
            })
        },

        /**
         *
         */
        errorWarehouseType(error) {
            this.setSnackbar({
                type: 'error',
                title: 'Error.',
                message: TranslatorService(
                    WarehouseTypeModel,
                    error.response.data
                ),
                timeout: 3000,
            })
        },

        /**
         *
         */
        showUpdate() {
            this.update = true
        },

        /**
         *
         */
        showWarehouse() {
            this.warehouse = true
        },

        /**
         *
         */
        showWarehouseType() {
            this.warehouseType = true
        },

        /**
         *
         */
        submitDelete(event) {
            //
            this.setSnackbar({
                type: 'warning',
                title: 'Eliminar bodega.',
                message: '¿Confirma la eliminación de la bodega?',
                confirm: 'eliminar',
            })

            //
            this.selected = event.item
        },

        /**
         *
         */
        submitDetail(event) {
            this.selected = event.item
            this.updateFormData = event.item
        },

        /**
         *
         */
        submitUpdate() {
            this.$refs.updateForm.setWait(true).then(this.updateWarehouse)
        },

        /**
         *
         */
        submitWarehouse() {
            this.$refs.warehouseForm.setWait(true).then(this.createWarehouse)
        },

        /**
         *
         */
        submitWarehouseType() {
            this.$refs.warehouseTypeForm
                .setWait(true)
                .then(this.createWarehouseType)
        },

        /**
         *
         */
        successDelete() {
            this.setSnackbar({
                type: 'success',
                title: 'Éxito.',
                message: 'Bodega eliminada con éxito.',
                timeout: 3000,
            })
        },

        /**
         *
         */
        successUpdate() {
            this.setSnackbar({
                type: 'success',
                title: 'Éxito.',
                message: 'Bodega actualizada con éxito.',
                timeout: 3000,
            })
        },

        /**
         *
         */
        successWarehouse() {
            this.setSnackbar({
                type: 'success',
                title: 'Éxito.',
                message: 'Bodega creada con éxito.',
                timeout: 3000,
            })
        },

        /**
         *
         */
        updateWarehouse(model) {
            model
                .toUpdate()
                .save()
                .then(this.successUpdate)
                .catch(this.errorWarehouse)
                .then(this.closeUpdate)
                .then(this.$refs.table.refresh)
                .then(this.$refs.updateForm.setWait)
        },
    },
    beforeMount() {
        this.setTitleTopBar('Bodegas')
        this.setItemsTopBar([
            {
                action: this.showWarehouseType,
                color: 'accent',
                icon: 'add_circle',
                text: 'crear tipo de bodega',
                tip: 'Crear nuevo tipo de bodega',
                can: 'CREATE_WAREHOUSE_TYPE',
            },
            {
                action: this.showWarehouse,
                color: 'accent',
                icon: 'add_circle',
                text: 'crear bodega',
                tip: 'Crear nueva bodega',
                can: 'CREATE_WAREHOUSE',
            },
        ])
    },
    watch: {
        /**
         *
         */
        async responseConfirm(value) {
            switch (value) {
                case 'eliminar':
                    return this.selected
                        .delete()
                        .then(this.successDelete)
                        .then(this.$refs.table.refresh)
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_WAREHOUSE')) ctx.$router.push('/')
        })
    },
}
